import React from 'react';
import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { validateBase } from './validations.js';

export const devCommand = (services: CommandServices, cliVersion: string) => {
  return createCommand('dev')
    .option(
      '--port <port>',
      'Specify which port to run on. Defaults to 4321.',
      (value) => {
        return parseInt(value, 10);
      }
    )
    .option(
      '--allowed-hosts <allowedHosts>',
      'Specify a comma-separated list of allowed hosts or allow any hostname.'
    )
    .addOption(
      new Option(
        '--base-url <url>',
        'The base url for when static files have been uploaded to an external cdn'
      )
        .argParser(validateBase)
        .hideHelp()
    )
    .action(async (options, command) => {
      const { DevCommand } = await import('../components/DevCommand/index.js');
      const { renderCommand } = await import('./render-command.js');

      await renderCommand(
        command,
        services,
        cliVersion,
        <DevCommand
          port={options.port}
          allowedHosts={options.allowedHosts}
          serverExposedUrl={options.baseUrl}
        />
      );
    });
};
